import React from 'react';

const formatDuration = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
};

const RecordingItem = ({ recording, onPlay, onDownload }) => {
  return (
    <tr>
      <td>{recording.title}</td>
      <td>{new Date(recording.created_at).toLocaleString()}</td>
      <td>{formatDuration(recording.duration)}</td>
      <td>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          onClick={() => onPlay(recording)}
          disabled={!recording.video_url}
          title={recording.video_url ? '' : 'No playable URL stored on server'}
        >
          Play
        </button>
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onDownload(recording)}
          disabled={!recording.video_url}
          title={recording.video_url ? '' : 'No downloadable URL stored on server'}
        >
          Download
        </button>
      </td>
    </tr>
  );
};

export default RecordingItem;
